/**
 * Dependencies.
 */
import { createElement as el } from "@wordpress/element";
import AppConfig from "../../services/appConfig";
import "./linkBox.css";

/**
 * Provides a LinkBox.
 *
 * @return {element} LinkBox.
 */
const LinkBox = () => {
  const { wpgPremiumURL, wpgOptionsURL } = AppConfig();
  return el(
    "div",
    {
      className: "wpglobus-switcher-tab-content__link-box",
    },
    el(
      "div",
      {
        className: "wpglobus-switcher-tab-content__button-link",
      },
      el(
        "a",
        {
          className: " wpglobus-switcher-tab-content__info-link",
          href: wpgPremiumURL,
          //isLink: true,
          target: "_blank",
        },
        "WPGlobus Premium"
      )
    ),
    el(
      "div",
      {
        className: "wpglobus-switcher-tab-content__button-link",
      },
      el(
        "a",
        {
          className: "wpglobus-switcher-tab-content__options-link",
          href: wpgOptionsURL,
          //isLink: true,
          target: "_blank",
        },
        "WPGlobus Options"
      )
    )
  );
};

export default LinkBox;
